import { useMemo } from 'react';

import classNames from 'classnames';
import i18n from 'providers/Locale';
import useLanguage from 'providers/Locale/hooks';
import { LanguagesEnum } from 'types/languages';

import ChoiceLogoIcon from '../icons/ChoiceLogo';

import styles from './PoweredBy.module.scss';

type PoweredByProps = {
	className?: string;
};

export const PoweredBy: React.FC<PoweredByProps> = ({ className }) => {
	const { currentLanguage } = useLanguage();

	const powerByUrl = useMemo(() => {
		let url = 'https://choiceqr.com/';

		if (currentLanguage === LanguagesEnum.cz) {
			url += 'cs';
		} else if (currentLanguage === LanguagesEnum.uk) {
			url += 'uk/?utm_source=referal&utm_medium=footer&utm_campaign=menu-clients';
		} else {
			url += currentLanguage;
		}

		return url;
	}, [currentLanguage]);

	return (
		<div className={classNames(styles.root, className)}>
			<p>{i18n('poweredBy')}</p>
			<a title={`${i18n('poweredBy')} - Choice`} href={powerByUrl} target="_blank" rel="noreferrer">
				<ChoiceLogoIcon />
			</a>
		</div>
	);
};
